import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faShip, faRobot, faSpinner, faAnchor, faLocationArrow, faLongArrowAltDown, faSyncAlt, faLongArrowAltUp,
  faLongArrowAltRight, faCircle, faExclamationTriangle, faHistory, faBatteryEmpty, faBatteryFull, faBatteryHalf,
  faBatteryQuarter, faBatteryThreeQuarters, faChevronLeft, faMapMarkedAlt, faChevronRight, faChartBar,
  faChevronCircleLeft, faAngleDoubleLeft, faAngleDoubleRight, faExternalLinkAlt, faGlobe, faGlobeEurope,
  faUserFriends, faUsers, faAngleRight, faMapMarkerAlt, faAngleDoubleUp, faArrowsAltH, faExternalLinkSquareAlt,
  faInfoCircle, faEye, faEdit, faCopy, faRss, faBroadcastTower, faAngleLeft, faVideo
} from '@fortawesome/free-solid-svg-icons'
import {
  faClock, faDotCircle, faCalendarAlt, faBuilding, faUser, faAddressCard, faIdBadge, faIdCard, faCompass
} from '@fortawesome/free-regular-svg-icons'
import {
  faTwitter, faFacebook, faInstagram, faYoutube
} from '@fortawesome/free-brands-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faCompass)
library.add(faBroadcastTower)
library.add(faRss)
library.add(faCopy)
library.add(faEye)
library.add(faEdit)
library.add(faYoutube)
library.add(faTwitter)
library.add(faFacebook)
library.add(faInstagram)
library.add(faAngleDoubleUp)
library.add(faMapMarkerAlt)
library.add(faAngleRight)
library.add(faAngleLeft)
library.add(faIdCard)
library.add(faIdBadge)
library.add(faAddressCard)
library.add(faUser)
library.add(faUsers)
library.add(faCalendarAlt)
library.add(faGlobe)
library.add(faUserFriends)
library.add(faBuilding)
library.add(faGlobeEurope)
library.add(faShip)
library.add(faChartBar)
library.add(faMapMarkedAlt)
library.add(faRobot)
library.add(faAnchor)
library.add(faCircle)
library.add(faLocationArrow)
library.add(faLongArrowAltUp)
library.add(faLongArrowAltDown)
library.add(faLongArrowAltRight)
library.add(faChevronLeft)
library.add(faChevronCircleLeft)
library.add(faAngleDoubleLeft)
library.add(faAngleDoubleRight)
library.add(faChevronRight)
library.add(faExclamationTriangle)
library.add(faHistory)
library.add(faClock)
library.add(faSyncAlt)
library.add(faSpinner)
library.add(faBatteryQuarter)
library.add(faBatteryThreeQuarters)
library.add(faBatteryHalf)
library.add(faBatteryFull)
library.add(faBatteryEmpty)
library.add(faDotCircle)
library.add(faExternalLinkAlt)
library.add(faExternalLinkSquareAlt)
library.add(faArrowsAltH)
library.add(faInfoCircle)
library.add(faVideo)

Vue.component('font-awesome-icon', FontAwesomeIcon)
